import {injectable} from "inversify";
import IInitApp from "../IInitApp";

@injectable()
export default class InitPixiApp implements IInitApp {
    constructor() {}

    init() {}

}